import { combineReducers } from 'redux';
import { customer } from './customer';


export default combineReducers({
	sessions : customer
})
